var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 56,
    viewBox: "0 0 46 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 1.3335H7.00029C5.58579 1.3335 4.22929 1.89541 3.22909 2.8956C2.22889 3.89579 1.66699 5.25235 1.66699 6.66683V49.3335C1.66699 50.748 2.22889 52.1045 3.22909 53.1047C4.22929 54.1049 5.58579 54.6668 7.00029 54.6668H39.0003C40.4148 54.6668 41.7714 54.1049 42.7716 53.1047C43.7718 52.1045 44.3337 50.748 44.3337 49.3335V17.3335M28.3337 1.3335L44.3337 17.3335M28.3337 1.3335V17.3335H44.3337M23.0003 44.0001V28.0001M15.0003 36.0001H31.0003",
    stroke: "#1C1B1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.c4240a467cc97b13291a02482c12457b.svg";
export { ForwardRef as ReactComponent };